<template>
  <section class="lg:px-16 py-6 px-4 grid gap-6 lg:grid-cols-2">
      <div>
          <p class="text-navy text-sm">WHAT WE STAND FOR</p>
          <h2 class="text-current text-3xl mt-4 font-semibold">Insurance should be easily accessible to anyone</h2>
          <p class="text-sm text-current mt-4">PaddyCover works with established insurers and customer aggregators to design and offer bespoke products via a multi-channel platform that facilitates flexible and convenient payment for insurance packages. </p>
          <p class="text-sm text-current mt-1">Our focus is to adopt and distribute key Insurance products e.g. Life and Health & Wellbeing Insurance - amongst others - as a means of building a model of prevention towards risk & strengthening resilience in our addressable market.</p>
          <p class="text-sm text-current mt-1">Paddycover innovatively takes the off-the-shelve products of underwriters and then work with them to create bespoke products ( to fit price and need) for its customers (who are aggregators).</p>
      </div>
      <div class="lg:flex justify-end">
          <img class="block" src="@/assets/images/aboutpage/Insurance.png" alt="various insurance covers image">
      </div>
  </section>
</template>

<script>
export default {
}
</script>

<style>
@media only screen and (min-width: 1024px){
    section{
        padding-left: 10%;
        padding-right: 10%;
    }
}
</style>